module.exports = __webpack_public_path__ + "img/service-01-pic-2.67907c1c.jpg";